import React from "react";
import "../assets/styles/components/NotreEquipe.css";
import collaborateur1 from "../assets/images/sophie-martin.jpg";
import collaborateur2 from "../assets/images/claire-dupont.jpg";
import collaborateur3 from "../assets/images/jean-leroy.jpg";

const NotreEquipe = () => {
  const teamMembers = [
    {
      name: "Sophie Martin",
      role: "Directrice de Location",
      description:
        "Sophie supervise toutes les opérations de location, garantissant une expérience fluide et efficace pour nos clients.",
      image: collaborateur1,
    },
    {
      name: "Claire Dupont",
      role: "Responsable de la Salle de Réunion",
      description:
        "Claire est en charge de la gestion et de la coordination des réservations de nos salles de réunion, assurant un service de qualité.",
        image: collaborateur2,
    },
    {
      name: "Jean Leroy",
      role: "Gestionnaire de Bureau Partagé",
      description:
        "Jean s'occupe de la gestion des espaces de coworking, favorisant un environnement collaboratif et productif.",
        image: collaborateur3,
    },
  ];

  return (
    <section id="notre-equipe" className="py-5">
      <div className="container text-center">
        <h2 className="section-title">Notre équipe</h2>
        <p className="section-subtitle">Rencontrez notre équipe dédiée</p>
        <div className="row">
          {teamMembers.map((member, index) => (
            <div className="col-md-4 mb-4" key={index}>
              <div className="card team-card">
                <img
                  src={member.image}
                  alt={member.name}
                  className="card-img-top img-fluid"
                />
                <div className="card-body">
                  <h3 className="card-title">{member.name}</h3>
                  <p className="card-role">{member.role}</p>
                  <p className="card-text">{member.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NotreEquipe;
